export default { sha: '0a685982c2288e32a0f846c082f73a3ab3c4169d', buildNumber: 'undefined' }
